import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Tercero } from '../../_models/tercero';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { Localizaciones } from '../../_models/localizaciones';
import { LocalizacionesService } from '../../_services/localizaciones.service';
import { forkJoin } from 'rxjs';
import { DivisionPoliticaService } from '../../_services/division-politica.service';
import { DivisionPolitica } from '../../_models/division-politica';
import { EstructuraFisicaService } from '../../_services/estructura-fisica.service';
import { EstructuraFisica } from '../../_models/estructura-fisica';
import { Utilidades } from '../../utils/utilidades';
import { AliadoSucursal } from '../../_models/aliado-sucursal';
import { AliadoSucursalService } from '../../_services/aliado-sucursal.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TerceroService } from '../../_services/tercero.service';
import { Location } from '@angular/common';
import { AliadoUsuarioService } from '../../_services/aliado-usuario.service';
import { AliadoUsuario } from '../../_models/aliado-usuario';
import { Aliado } from '../../_models/aliado';
import { AliadoService } from '../../_services/aliado.service';
import { AliadoSucursalCupoService } from '../../_services/aliado-sucursal-cupo.service';
import { AliadoSucursalCupo } from '../../_models/aliado-sucursal-cupo';
import moment from 'moment';
import 'moment/locale/es';
import { AliadoUsuarioMovimientoService } from '../../_services/aliado-usuario-movimiento.service';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { AppSettingService } from '../../_services/app-setting.service';

@Component( {
  selector: 'app-aliados-sucursales-editar',
  templateUrl: 'aliados-sucursales-editar.component.html'
} )

export class AliadosSucursalesEditarComponent implements OnInit {

  sucursal: AliadoSucursal;
  tercero: Tercero;
  carInformacionInicial = true;
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  localizacion: Localizaciones = new Localizaciones();
  addinglocation = true;
  carMunicipio = false;
  municipio: DivisionPolitica = new DivisionPolitica();
  lisOficinaVirtual: SelectItem[] = [];
  utilidades = new Utilidades();
  idAliado: string;
  tabSeleccionado = 'INFO';
  aliado: Aliado;


  constructor( private sucServicio: AliadoSucursalService,
               private conServicio: ConfirmationService,
               private nav: NavService,
               private locServicio: LocalizacionesService,
               private divPoliticaServicio: DivisionPoliticaService,
               private estFisicaServicio: EstructuraFisicaService,
               private route: ActivatedRoute,
               private terServicio: TerceroService,
               private location: Location,
               private aliUsuarioServicio: AliadoUsuarioService,
               private aliServicio: AliadoService,
               private aliSucursalCupoServicio: AliadoSucursalCupoService,
               private router: Router,
               private aliUsuarioMovimientoServicio: AliadoUsuarioMovimientoService,
               private autServicio: AutenticacionService,
               private fb: FormBuilder,
               public appSettingService: AppSettingService ) {
  }

  ngOnInit(): void {
    this.route.params.subscribe( ( params: Params ) => {
      this.idAliado = params[ 'id' ];
      if ( params[ 'idSucursal' ] ) {
        this.sucServicio.obtenerPorIdConCampos( params[ 'idSucursal' ] ).subscribe( sucursal => {
          this.sucursal = sucursal;
          if ( this.sucursal && this.sucursal.idLocalizacion ) {
            this.locServicio.getById( this.sucursal.idLocalizacion, false ).subscribe( loc => {
              this.localizacion = loc;
              this.divPoliticaServicio.obtenerPorId( this.localizacion.idDivisionPolitica ).subscribe( div => {
                this.municipio = div;
                this.cargarServicios();
              } );
            } );
          } else {
            this.cargarServicios();
          }
        } );
      } else {
        this.cargarServicios();
      }
    } );
  }

  cargarServicios() {
    forkJoin( this.aliServicio.obtenerPorId( this.idAliado ),
      this.estFisicaServicio.getAllEnabled() ).subscribe( ( [ aliado, lisOficinas ] ) => {
      this.aliado = aliado;
      this.terServicio.get( this.aliado.idTercero ).subscribe( ter => {
        this.tercero = ter;
        lisOficinas.map( ( s: EstructuraFisica ) => {
          this.lisOficinaVirtual.push( { label: s.estructuraFisica, value: s.idEstructuraFisica } );
        } );
        this.cargarFormulario();
      } );
    } );
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idAliadoSucursal: [ this.sucursal ? this.sucursal.idAliadoSucursal : null ],
      idAliado: [ this.sucursal ? this.sucursal.idAliado : this.aliado.idAliado, [ Validators.required ] ],
      codigo: [ this.sucursal ? this.sucursal.codigo : null, [ Validators.required, Validators.maxLength( 8 ) ] ],
      nombre: [ this.sucursal ? this.sucursal.nombre : null, [ Validators.required, Validators.maxLength( 150 ) ] ],
      cupoValor: [ this.sucursal ? this.sucursal.cupoValor : null, [ Validators.required, Validators.maxLength( 20 ) ] ],
      cupoCredito: [ this.sucursal ? this.sucursal.cupoCredito : null, [ Validators.required, Validators.maxLength( 5 ) ] ],
      idLocalizacion: [ this.sucursal ? this.sucursal.idLocalizacion : null ],
      direccion: [ {
        value: this.localizacion ? this.localizacion.direccion : null,
        disabled: true
      }, [ Validators.required ] ],
      indicadorPrincipal: [ this.sucursal ? this.sucursal.indicadorPrincipal : false ],
      indicadorHabilitado: [ this.sucursal ? this.sucursal.indicadorHabilitado : true ],
      idEstructuraFisica: [ this.sucursal ? this.sucursal.idEstructuraFisica : null, [ Validators.required ] ],
      alias: [ this.sucursal ? this.sucursal.alias : null ]
    } );
    this.carInformacionInicial = false;
  }

  guardar( editar: AliadoSucursal, principal: AliadoSucursal, listado: AliadoUsuario[] ) {
    this.localizacion.indicadorHabilitado = true;
    const peticiones = [];
    if ( principal ) {
      principal.indicadorPrincipal = false;
      peticiones.push( this.sucServicio.actualizar( principal ) );
    }

    if ( listado.length > 0 ) {
      peticiones.push( this.aliUsuarioServicio.bulk( listado ) );
      peticiones.push( this.aliUsuarioServicio.actualizarAliadoBulk( listado.map( ( s: AliadoUsuario ) => s.idUsuario ), false ) );
    }
    const tipo = !this.sucursal ? 1 : 2;
    const cambio = !this.sucursal || this.sucursal.cupoCredito !== editar.cupoCredito || this.sucursal.cupoValor !== editar.cupoValor;
    if ( this.localizacion && (this.localizacion.idLocalizacion !== null && this.localizacion.idLocalizacion !== '' && this.localizacion.idLocalizacion !== undefined) ) {
      peticiones.push( this.locServicio.update( this.localizacion, false ) );
      peticiones.push( editar.idAliadoSucursal ? this.sucServicio.actualizar( editar ) : this.sucServicio.crear( editar ) );
      forkJoin( peticiones ).subscribe( r => {
        editar.idAliadoSucursal = (r[ r.length - 1 ] as any).idAliadoSucursal;
        this.f.idAliadoSucursal.setValue( editar.idAliadoSucursal );
        this.f.indicadorPrincipal.setValue( editar.indicadorPrincipal );
        this.sucursal = editar;
        this.guardarCupo( tipo, cambio );
      } );
    } else {
      this.locServicio.add( this.localizacion, false ).subscribe( localizacion => {
        editar.idLocalizacion = localizacion.idLocalizacion;
        peticiones.push( editar.idAliadoSucursal ? this.sucServicio.actualizar( editar ) : this.sucServicio.crear( editar ) );
        forkJoin( peticiones ).subscribe( r => {
          editar.idAliadoSucursal = (r[ r.length - 1 ] as any).idAliadoSucursal;
          this.f.idAliadoSucursal.setValue( editar.idAliadoSucursal );
          this.f.indicadorPrincipal.setValue( editar.indicadorPrincipal );
          this.sucursal = editar;
          this.guardarCupo( tipo, cambio );
        } );
      } );
    }
  }

  guardarCupo( tipo: number, cambio: boolean ) {
    if ( cambio ) {
      const a = {} as AliadoSucursalCupo;
      a.idAliadoSucursal = this.sucursal.idAliadoSucursal;
      a.cupoCreditos = this.sucursal.cupoCredito;
      a.cupoValor = this.sucursal.cupoValor;
      a.fechaActualizado = moment().format();
      a.fechaInicio = new Date();
      a.fechaFin = new Date();
      a.indicadorHabilitado = true;
      this.aliSucursalCupoServicio.crear( a ).subscribe( nueCupo => {
        this.aliUsuarioMovimientoServicio.generarMovimientoAliado( this.sucursal.idAliadoSucursal, this.autServicio.obtenerIdUsuarioLogueado(), this.sucursal.cupoValor, this.sucursal.cupoCredito, 'TOPEMOD' ).subscribe( mov => {
          this.verificarSalir( tipo );
        } );
      } );
    } else {
      this.verificarSalir( tipo );
    }
  }

  verificarSalir( tipo: number ) {
    this.guardando = false;
    this.nav.setMesage( tipo );
    this.regresar( false );
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid && this.f.direccion.value && this.f.direccion.value !== '' ) {
      this.guardando = true;
      const registro = this.formulario.getRawValue();
      if ( registro && registro.indicadorPrincipal && !registro.indicadorHabilitado && !registro.idAliadoSucursal ) {
        this.mostrarMensajePrincipalHabilitado();
      } else {
        if ( !this.sucursal || this.sucursal.codigo !== registro.codigo ) {
          this.sucServicio.obtenerPorCodigo( registro.codigo, this.aliado.idAliado ).subscribe( codigo => {
            if ( !codigo || codigo.idAliadoSucursal === registro.idAliadoSucursal ) {
              this.validarSinCodigo( registro, !this.sucursal );
            } else {
              this.nav.setMesage( 0, {
                severity: 'info', summary: this.nav.buscarMensaje( 'LBL_INFORMACION' ),
                detail: this.nav.buscarMensaje( 'SUCURSALES.MSG_EXISTECODIGO' )
              } );
              this.guardando = false;
            }
          }, error => {
            this.nav.setMesage( 3 );
            this.guardando = false;
          } );
        } else {
          this.validarSinCodigo( registro );
        }
      }
    }
  }

  validarSinCodigo( registro: any, nuevo: boolean = false ) {
    if ( !nuevo && !registro.indicadorHabilitado ) {
      this.validarAliadosUsuarios( registro );
    } else {
      this.validarPrincipal( registro, [] );
    }
  }

  mostrarMensajePrincipalHabilitado() {
    this.nav.setMesage( 0, {
      severity: 'info', summary: this.nav.buscarMensaje( 'LBL_INFORMACION' ),
      detail: this.nav.buscarMensaje( 'SUCURSALES.MSG_NOSEPUEDEHABILITAR' )
    } );
    this.guardando = false;
  }

  validarAliadosUsuarios( registro: any ) {
    this.aliUsuarioServicio.listadoPorSucursal( registro.idAliadoSucursal ).subscribe( listado => {
      const l = listado.filter( x => x.indicadorHabilitado );
      if ( l.length > 0 ) {
        this.conServicio.confirm( {
          message: this.nav.buscarMensaje( 'SUCURSALES.MSG_EXISTENALIADOSHABILITADOS' ),
          header: this.nav.buscarMensaje( 'LBL_CONFIRMACION' ),
          icon: 'fa fa-question-circle',
          key: 'sucursal',
          accept: () => {
            listado.map( ( s: AliadoUsuario ) => {
              s.indicadorHabilitado = false;
            } );
            this.validarPrincipal( registro, listado );
          },
          reject: () => {
            this.guardando = false;
          }
        } );
      } else {
        this.validarPrincipal( registro, listado );
      }
    } );
  }

  validarPrincipal( registro: any, listado: AliadoUsuario[] ) {
    this.sucServicio.obtenerPrincipal( this.aliado.idAliado ).subscribe( principal => {
      if ( ( !principal && registro && !registro.indicadorPrincipal ) || ( registro && principal && principal.idAliadoSucursal === registro.idAliadoSucursal && !registro.indicadorPrincipal ) ) {
        this.nav.setMesage( 0, {
          severity: 'info', summary: this.nav.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.nav.buscarMensaje( 'SUCURSALES.MSG_DEBEEXISTIRPRINCIPAL' )
        } );
        this.guardando = false;
      } else if ( principal && principal.idAliadoSucursal === registro.idAliadoSucursal && !registro.indicadorHabilitado ) {
        this.sucServicio.obtenerPorAliado( this.aliado.idAliado ).subscribe( l => {
          const exiOtro = l.find( x => x.indicadorHabilitado && x.idAliadoSucursal !== registro.idAliadoSucursal );
          if ( !!exiOtro ) {
            this.mostrarMensajePrincipalHabilitado();
          } else {
            this.validarCupoPermitido( registro, null, listado );
          }
        } );
      } else if ( principal && principal.idAliadoSucursal !== registro.idAliadoSucursal && registro.indicadorHabilitado && ( registro.indicadorPrincipal || !principal.indicadorHabilitado ) ) {
        this.conServicio.confirm( {
          message: this.nav.buscarMensaje( registro.indicadorPrincipal ? 'SUCURSALES.MSG_EXISTEPRINCIPAL' : 'SUCURSALES.MSG_ACTUALIZARPRINCIPAL' ),
          header: this.nav.buscarMensaje( 'LBL_CONFIRMACION' ),
          icon: 'fa fa-question-circle',
          key: 'sucursal',
          accept: () => {
            registro.indicadorPrincipal = true;
            this.validarCupoPermitido( registro, principal, listado );
          },
          reject: () => {
            this.guardando = false;
          }
        } );
      } else if ( principal && principal.idAliadoSucursal !== registro.idAliadoSucursal && registro.indicadorPrincipal && !registro.indicadorHabilitado ) {
        this.mostrarMensajePrincipalHabilitado();
      } else {
        this.validarCupoPermitido( registro, null, listado );
      }
    }, error => {
      this.nav.setMesage( 3 );
      this.guardando = false;
    } );
  }


  validarCupoPermitido( editar: AliadoSucursal, principal: AliadoSucursal, listado: AliadoUsuario[] ) {
    if ( this.sucursal && ( this.sucursal.cupoCredito > editar.cupoCredito || this.sucursal.cupoValor > editar.cupoValor ) ) {
      this.aliUsuarioMovimientoServicio.obtenerUltimo( this.sucursal.idAliadoSucursal ).subscribe( l => {
        const nuevoValor = ( l.saldo + ( editar.cupoValor - this.sucursal.cupoValor ) );
        const nuevoCupoCredito = ( l.saldoCreditos + ( editar.cupoCredito - this.sucursal.cupoCredito ) );
        if ( l && ( nuevoValor < 0 || nuevoCupoCredito < 0 ) ) {
          this.nav.setMesage( 0, {
            severity: 'info', summary: this.nav.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.nav.buscarMensaje( 'SUCURSALES.MSG_NOPUEDEBAJARMONTO' )
          } );
          this.guardando = false;
          this.f.cupoValor.setValue( this.sucursal.cupoValor );
          this.f.cupoCredito.setValue( this.sucursal.cupoCredito );
        } else {
          this.guardar( editar, principal, listado );
        }
      } );
    } else {
      this.guardar( editar, principal, listado );
    }
  }

  get f() {
    return this.formulario.controls;
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.nav.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.nav.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'sucursal',
        accept: () => {
          this.router.navigate( [ 'apl/aliados/sucursales/' + this.aliado.idAliado ] );
        },
        reject: () => {
        }
      } );
    } else {
      this.router.navigate( [ 'apl/aliados/sucursales/' + this.aliado.idAliado ] );
    }
  }

  toggleform() {
    this.addinglocation = !this.addinglocation;
  }

  bindLocation( event: any ) {
    this.localizacion = event;
    this.f.direccion.setValue( event.direccion );
    this.carMunicipio = true;
    this.divPoliticaServicio.obtenerPorId( this.localizacion.idDivisionPolitica ).subscribe( div => {
      this.municipio = div;
      this.carMunicipio = false;
    } );
    this.toggleform();
  }

  abrirAcordeon( evento: any ) {
    switch ( evento.index ) {
      case 0: {
        this.tabSeleccionado = 'INFO';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'CUPOS';
        break;
      }
      case 2: {
        this.tabSeleccionado = 'USUARIOS';
        break;
      }
      default: {
        break;
      }
    }
  }

  cambiarTabSeleccionado( tab: string ) {
    this.tabSeleccionado = tab;
  }
}
